<template>
	<div class="home-container">
		<div class="linear-bg"></div>
		<div class="home-scroll">
			<div class="banner">
				<swiper class="banner_swiper" :options="bannerSwiperOption">
					<swiper-slide v-for="(v, key) in banners" :key="key">
						<van-image class="banner_img" round :src="v.url">
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
					</swiper-slide>
				</swiper>
			</div>
			<div class="notice-bar">
				<van-notice-bar class="notice-swipe" left-icon="volume-o" background="#ffffff" color="#000"
					:text="this.notice" />
			</div>

			<div class="nav_box">
				<div class="x_p" @click="gotoMenu('/Game')">
					<van-image width="40px" height="40px"   radius="10"  src="/img/home-ico01-data.png">
						<template v-slot:loading>
							<van-loading type="circular" />
						</template>
					</van-image>
					<div>{{$t('nav.game')}}</div>
					
				</div>
				<div class="x_p" @click="gotoMenu('/ServiceOnline')">
					<van-image width="40px" height="40px"   radius="10"  src="/img/home-ico02-help.png">
						<template v-slot:loading>
							<van-loading type="circular" />
						</template>
					</van-image>
					<div>{{$t('page.ordlan.help')}}</div>
				</div>
				<div class="x_p" @click="gotoMenu('/Video')">
					<van-image width="40px" height="40px"   radius="10"  src="/img/home-ico03-moveies.png">
						<template v-slot:loading>
							<van-loading type="circular" />
						</template>
					</van-image>
					<div>{{ $t('nav.video') }} </div>
				</div>
				<div class="x_p" @click="gotoMenu('/Choose')" >
					<van-image width="40px" height="40px"   radius="10"  src="/img/home-ico04-vip.png">
						<template v-slot:loading>
							<van-loading type="circular" />
						</template>
					</van-image>
					<div>
						{{ $t('nav.list') }}
					</div>
				</div>
			</div>

			<div class="agent">
				<p>{{$t('page.ordlan.AgencyBooking')}}</p>
				<p @click="gotoMenu('/Choose')">{{$t('page.ordlan.More')}}</p>
			</div>


			<div class="">
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
					<div class="tu_list">
						<van-list v-model="loading" :finished="finished" :immediate-check="false"
							:finished-text="$t('page.video.noMore')" @load="onLoad">
							<div>
								<div class="item" v-for="(v,key) in datalist" :key="key" @click="toPlayVideo(v.id)">
									<div class="left">
										<van-image class="cover_img" width="120px" height="120px" radius="10"
											:src="v.img_url">
											<template v-slot:loading>
												<van-loading type="circular" />
											</template>
										</van-image>
										<div class="item_id">{{ v.username }}</div>
									</div>
									<div class="right">
										<div class="badge-container">
											<span class="badge-item">
												<span class="badge-icon">
													<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy9JREFUWEfdlk1IVFEUx//nOfaxKVpEgcsWSh/gwr5oUUb0tYjAdDFvtBZR2dyRgqLSeYPNGzWCEHxvJFplzhtBJXCVFfS1CCsjCGzRxz4K3LUp5514b7RGe3fem7EQust3zrn/3zn3nPsuYYkXLbE+lh5gUBd7yq1Cs2Y+WRhb6n7kBCjAPQArSgD5ZAMnZQAK8DjIXjZQ7x5Bpju2kXI8DGCTXyAzn18WUqymduOrzHe4O7Z2xuZGZqQ9fD7YNrLLubKvqbN3el4PWLr4DGBdMQiH2itzrxhLFx8BbCi0MehARDMezH2bD9B1tha28qYYAIFvhLX0Bb9KOXZLF9MA1sz5MtAT0cz2wtg/piCTjJ4jol6pAOO9mjCr/QCGktHtNtHE70xpPKwZhxbGeY6hpYvnAHbKRHLMO1oS6RfFILJ67CKDr//yYaVOTfS9DgaQiqlgzhQR6FQ182pxgOgIg465PoRbatw87eUvvYgsXdwHsN8ziDAZjptbZQDZblFj5/CWgErXR5J9nk2yhnRxxAbGZHYiPhGOpwe87BldpAjo8Mu+KIBjzKbEKDMaJBDPVM3cvdA2fO3S6pkf36YYqPLL3hfA6mqrh20/kp41oUmNmyOFdisZEyA2gmTvC+A4ZHRxm4DjXhAMHo9o6XmjZenCuUdqg2QfCGAoJepsxktpvyg4qHaYTsM6R9bAjNGg2QcCcJyspDBAEJKjuKtqptsnhZPDbG+LJPpfSY9v1hDoPZDtFDVcAefiWeW1oU32LgUUAtPTfPY0psaNo37igSvgllcX3Qxc8e4FDBA4BJDq2G2icHPcGPqrAAOpM1UVHJokYL3PxlPhuLGFiPivArgTkRQ9RLjss3FC1Uw9iHhJR+A4D+qt1QoqnDFbKRH4DiibVa3vwz8ByHd6tB+gVonAHVUzPe8MGVCgKSgMtlKxbWD2/BWzgsORDtN5XwZeJQPkqxDLAOx2/Nwi8POwlt4VWHnWsVyAfQA/nA+AtrBm5v8BJayyAPJVEM4runFWayqXm9nb0nnzSwnarmvZAC5EMnqKocwghIlIu/GuVPFFA5QjuDBmURX4LwB+Ajq/G9S6JXoiAAAAAElFTkSuQmCC"
														alt="VIP" class="vip_image">
												</span>
												{{ $t('page.ordlan.IdentityVerification') }}
											</span>
											<span class="badge-item">
												<span class="badge-icon">
													<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy9JREFUWEfdlk1IVFEUx//nOfaxKVpEgcsWSh/gwr5oUUb0tYjAdDFvtBZR2dyRgqLSeYPNGzWCEHxvJFplzhtBJXCVFfS1CCsjCGzRxz4K3LUp5514b7RGe3fem7EQust3zrn/3zn3nPsuYYkXLbE+lh5gUBd7yq1Cs2Y+WRhb6n7kBCjAPQArSgD5ZAMnZQAK8DjIXjZQ7x5Bpju2kXI8DGCTXyAzn18WUqymduOrzHe4O7Z2xuZGZqQ9fD7YNrLLubKvqbN3el4PWLr4DGBdMQiH2itzrxhLFx8BbCi0MehARDMezH2bD9B1tha28qYYAIFvhLX0Bb9KOXZLF9MA1sz5MtAT0cz2wtg/piCTjJ4jol6pAOO9mjCr/QCGktHtNtHE70xpPKwZhxbGeY6hpYvnAHbKRHLMO1oS6RfFILJ67CKDr//yYaVOTfS9DgaQiqlgzhQR6FQ182pxgOgIg465PoRbatw87eUvvYgsXdwHsN8ziDAZjptbZQDZblFj5/CWgErXR5J9nk2yhnRxxAbGZHYiPhGOpwe87BldpAjo8Mu+KIBjzKbEKDMaJBDPVM3cvdA2fO3S6pkf36YYqPLL3hfA6mqrh20/kp41oUmNmyOFdisZEyA2gmTvC+A4ZHRxm4DjXhAMHo9o6XmjZenCuUdqg2QfCGAoJepsxktpvyg4qHaYTsM6R9bAjNGg2QcCcJyspDBAEJKjuKtqptsnhZPDbG+LJPpfSY9v1hDoPZDtFDVcAefiWeW1oU32LgUUAtPTfPY0psaNo37igSvgllcX3Qxc8e4FDBA4BJDq2G2icHPcGPqrAAOpM1UVHJokYL3PxlPhuLGFiPivArgTkRQ9RLjss3FC1Uw9iHhJR+A4D+qt1QoqnDFbKRH4DiibVa3vwz8ByHd6tB+gVonAHVUzPe8MGVCgKSgMtlKxbWD2/BWzgsORDtN5XwZeJQPkqxDLAOx2/Nwi8POwlt4VWHnWsVyAfQA/nA+AtrBm5v8BJayyAPJVEM4runFWayqXm9nb0nnzSwnarmvZAC5EMnqKocwghIlIu/GuVPFFA5QjuDBmURX4LwB+Ajq/G9S6JXoiAAAAAElFTkSuQmCC"
														alt="VIP" class="vip_image">
												</span>
												{{ $t('page.ordlan.PersonalVideoVerification') }}
											</span>
										</div>
										<div class="info-container">
											<p class="star-rating">
												{{ $t('page.ordlan.Rating') }}:
												<span class="star" v-for="(v,key) in v.start"></span>
											</p>
											<div class="user-details">
												{{ v.xuanfei_name }}
											</div>
										</div>
										<div class="apply-btn">{{ $t('page.ordlan.AppointmentRequest') }} </div>
									</div>
								</div>

							</div>
						</van-list>
					</div>
				</van-pull-refresh>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

				active: 0,
				count: 0,
				loading: false,
				finished: false,
				refreshing: false,
				videolitem: [],
				datalist: [],
				number: 0,
				page: 0,
				videoSwiperOption: {
					slidesPerView: 'auto',
					spaceBetween: 0,
					slidesPerGroup: 1,
				},

				notice: this.$t('page.home.loadingData'),
				banners: [{}],
				basicData: [],
				gameitem: [{}, {}, {}, {}],
				movielist_0: [{}, {}, {}, {}],
				movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
				isLoading: false,
				movielistSwiperOption: {
					slidesPerView: 'auto',
					spaceBetween: 0,
					slidesPerGroup: 1,
				},
				bannerSwiperOption: {
					effect: 'coverflow',
					grabCursor: true,
					centeredSlides: true,
					slidesPerView: 'auto',
					speed: 800,
					autoplay: true,
					coverflowEffect: {
						rotate: 50,
						stretch: 10,
						depth: 100,
						modifier: 1,
						slideShadows: true
					}
				}
			};
		},
		created() {
			this.getBasicConfig();
			this.OnChange()
		},
		methods: {
			onLoad() {
				this.getxuanfeilistv2();
				let timer = setTimeout(() => {
					if (this.refreshing) {
						this.datalist = [];
						this.refreshing = false;
					}
					this.loading = false;
					if (this.datalist.length === this.count) {
						this.finished = true;
					}
					this.finished && clearTimeout(timer); //清除计时器
				}, 1500);
			},
			getxuanfeilistv2() {
				this.$http({
					method: 'get',
					data: {
						id: this.active,
						page: this.page
					},
					url: 'xuanfeilistv2'
				}).then(res => {
					this.page = this.page + 1;
					this.datalist = this.datalist.concat(res.data.data);
					this.count = res.data.count;
					this.page++;

				})
			},
			OnChange() {
				this.datalist = [];
				this.number = 0;
				this.page = 0;
				this.count = 0;
				this.getxuanfeilistv2(); //获取视频列表
			},
			onRefresh() {
				setTimeout(() => {
					this.finished = false;
					this.loading = true;
					this.onLoad();
					this.isLoading = false;
					Toast(this.$t('page.video.refreshSuccess'));
				}, 500);
			},
			gotoMenu(router) {
				this.$router.replace(router)
			},
			toLottery(key, id) {
				if (!localStorage.getItem('token')) {
					this.$router.push({
						path: '/Login'
					})
				} else {
					this.$router.push({
						path: '/Lottery?key=' + key + "&id=" + id
					})
				}

			},
			toPlayVideo(id) {
				// this.$router.push({ path: '/profile?id=' + id + '&name=' + this.vod_name + '&adsid=' + id });
				// return false;
				if (!localStorage.getItem('token')) {
					this.$router.push({
						path: '/Login'
					})
				} else {
					this.$router.push({
						path: '/profile?id=' + id
					})
				}

			},

			getBasicConfig() {
				this.$http({
					method: 'get',
					url: 'sys_config'
				}).then(res => {
					this.basicData = res.data;
					this.getNotice(this.basicData); //获取公告
					this.getBanner(this.basicData); //获取banner
					// this.getGameItem();//获取首页游戏列表
					// this.getMovieList_0(this.basicData);//获取首页视频0
					// this.getMovieList_1(this.basicData);//获取首页视频/1
				})

			},
			getNotice(data) {
				this.notice = data.notice;
			},
			getGameItem() {
				this.$http({
					method: 'get',
					url: 'lottery_hot'
				}).then(res => {
					this.gameitem = res.data
				})
			},
			getMovieList_0(data) {
				this.movielist_0 = data.movielist_0
			},
			getMovieList_1(data) {
				this.movielist_1 = data.movielist_1
			},
			getBanner(data) {
				this.banners = data.banners;
			}
		},
		mounted() {

		},

	}
</script>

<style lang='less' scoped>
	@notice-bar-size: 30px;
	@movie-list-item-bottom-size: 25px;

	.linear-bg {
		height: 200px;
		background: linear-gradient(135deg, #3498db, #8e44ad);
	}

	.home-container {
		position: absolute !important;
		top: 0;
		left: 0;
		right: 0;
		background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
	}

	.linear-gradient {
		width: 100%;
		height: 2px;
		background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));
	}

	::v-deep .van-notice-bar__left-icon,
	.van-notice-bar__right-icon {
		min-width: 40px;
	}

	.notice-swipe {
		/* width: calc(100% - 50px); */
		margin: 20px;
		border-radius: 20px;
		height: 85px;
		font-size: @notice-bar-size;
	}

	::v-deep .van-icon-bullhorn-o::before {
		transform: scale(2.5);
	}

	.banner {
		width: 100%;
		margin-top: -23%;
	}

	.banner_swiper {
		height: 100%;
		width: 100%;

		.swiper-slide {
			border-radius: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 620px;
			height: 300px;
			text-align: center;
			font-weight: bold;
			font-size: 20px;
			background-color: #ffffff;
			background-position: center;
			background-size: cover;
			color: #ffffff;
		}

	}

	::v-deep .swiper-container-3d .swiper-slide-shadow-left {
		background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
	}

	::v-deep .swiper-container-3d .swiper-slide-shadow-right {
		background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
	}

	.banner_img {
		border-radius: 10px;
		width: 100%;
		height: 100%;
	}

	.hot-game {
		width: 100%;
		height: 100%;
	}

	.hot-title-div {
		width: calc(100% - 6.667vw);
		margin: 0 auto;
		height: 10.667vw;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.hot-title-div>div:first-child {
		font-weight: bold;
	}


	.hot-game .hot-items-div {
		margin-top: -3px;
	}

	.hot-game .hot-items-div span {
		margin-top: 10px;
		font-size: 28px;
		color: #000;
	}

	.hot-recommend {
		width: 100%;
		flex: 1;
		background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
	}

	.movie_swiper {
		.swiper-slide {
			width: 80%;
		}

	}

	.movie_list_0 {
		width: calc(100% - 50px);
		margin: 0 auto;
	}

	.movie_cover {
		border-radius: 10px;
		width: 550px;
		height: 330px
	}

	.movie_list_0 .movie-list-item-bottom {
		position: relative;
		width: 550px;
		bottom: 43px;
	}

	.movie_list_0 .movie-list-item-bottom .movie-time-div {
		background-color: rgba(0, 0, 0, .4);
	}

	.movie_list_0 .movie-list-item-bottom>div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie_list_0 .movie-list-item-bottom .movie-time-div .van-count-down {
		font-size: 28px;
		color: #fff;
	}

	.movie_list_0 .movie-time-div {
		color: #fff;
		border-radius: 0 0 10px 10px;
	}

	.movie_list_0 .movie_swiper .hot {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 80px;
	}

	.movie_list_0 span {
		font-size: 30px;
	}

	.movie_list_1 {
		display: flex;
		width: calc(100% - 50px);
		margin: 0 auto;
		align-items: flex-start;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.movie_list_1 .movie-list-item .cover_img {
		border-radius: 10px;
		width: 335px;
		height: 290px;
	}

	.home-scroll {
		padding-bottom: 110px;
	}

	.movie_list_1 .movie-list-item {
		margin-bottom: -10px;
	}

	.movie_list_1 .movie-list-item-bottom {
		position: relative;
		width: 335px;
		bottom: 42px;
	}

	.movie_list_1 .movie-list-item:nth-child(odd) {
		margin-right: 25px;
	}

	.movie_list_1 .movie-list-item-bottom .movie-time-div {
		background-color: rgba(0, 0, 0, .4);
	}

	.movie_list_1 .movie-list-item-bottom>div {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.movie_list_1 .movie-list-item-bottom .movie-time-div .van-count-down {
		color: #fff;
	}

	.movie_list_1 .movie-time-div {
		color: #fff;
		border-radius: 0 0 10px 10px;
		height: 35px;
	}

	.movie_list_1 .movie_swiper .hot {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 5px;
	}

	.movie_list_1 .movie-list-item .movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 180px;
		padding-left: 8px;
		font-size: 25px;
	}

	.movie_list_1 .movie-list-item .movie-time-div span:last-child {
		overflow: hidden;
		white-space: nowrap;
		width: 0px;
		padding-right: 110px;
		font-size: 22px;
	}

	.movie_list_0 .movie-time-div span:first-child {
		overflow: hidden;
		white-space: nowrap;
		width: 350px;
		padding-left: 10px;
		font-size: 25px;
	}

	.hot-recommend-more {
		width: 100%;
		padding-bottom: 20px;
		text-align: center;
		color: #979799;
		font-size: 30px;
	}

	.hot-items-div .game_item_img {
		width: 100px;
		height: 100px;
	}

	::v-deep .hot-items-div .game_item_img .van-image__img {
		border-radius: 20px;
	}

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000000;
		font-size: 35px;
	}

	.my-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		line-height: 150px;
		text-align: center;
		background: linear-gradient(135deg, #3498db, #8e44ad);
	}


	.tu_list {
		/* height: 85vh; */
	}

	.tu_list .item {
		margin: 3.73333vw 2.66667vw 2.13333vw;
		padding: 3.2vw;
		border-radius: 2.66667vw;
		background: linear-gradient(135deg, #fff, #f8f9fa);
		border: 1px solid #fff;
		box-shadow: 0 .53333vw 2.66667vw #00000014;
		display: flex;
		justify-content: space-between;
		position: relative;
		overflow: hidden
	}

	.tu_list .item .left {
		width: 29.33333vw;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		border-radius: 1.33333vw;
		overflow: hidden
	}

	.tu_list .item .left .avatar {
		width: 100%;
		object-fit: cover;
		border-radius: 1.06667vw
	}

	.tu_list .item .left .item_id {
		color: #34196a;
		margin-top: 1.6vw;
		text-align: center;
		font-size: 3.73333vw
	}

	.tu_list .item .right {
		flex: 1;
		padding-left: 2.66667vw;
		margin-left: 3.2vw;
		display: flex;
		flex-direction: column;
		justify-content: space-between
	}

	.tu_list .item .right .badge-container {
		display: flex;
		margin-bottom: 1.6vw;
		gap: 2.13333vw
	}

	.tu_list .item .right .badge-container .badge-item {
		font-size: 2.93333vw;
		padding: 1.06667vw 2.66667vw;
		display: flex;
		align-items: center;
		color: #4a5568;
		background: linear-gradient(135deg, #667eea1a, #764ba21a);
		border-radius: 2.66667vw;
		border: 1px solid rgba(102, 126, 234, .2);
		font-weight: 500;
		box-shadow: 0 1px 1.06667vw #667eea1a;
		transition: all .3s ease;
		text-align: center
	}

	.tu_list .item .right .badge-container .badge-item .badge-icon {
		margin-right: .8vw;
		font-size: 3.2vw;
		color: #fff
	}

	.tu_list .item .right .badge-container .badge-item .vip_image {
		width: 1.86667vw;
		height: 1.86667vw;
		filter: drop-shadow(0 1px .267vw rgba(0, 0, 0, .1));
		object-fit: contain
	}

	.tu_list .item .right .info-container {
		background: #f8fafccc;
		padding: 1.6vw;
		border-radius: 1.6vw;
		margin-bottom: 1.6vw;
		border: 1px solid rgba(226, 232, 240, .6);
		-webkit-backdrop-filter: blur(1.33333vw);
		backdrop-filter: blur(1.33333vw)
	}

	.tu_list .item .right .info-container .star-rating {
		color: #e53e3e;
		font-weight: 700;
		margin-bottom: .8vw;
		font-size: 2.66667vw;
		display: flex;
		align-items: center
	}

	.tu_list .item .right .info-container .star {
		display: inline-block;
		width: 1.86667vw;
		height: 1.86667vw;
		background: url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill='%23f6ad55'%20d='M12%2017.27L18.18%2021l-1.64-7.03L22%209.24l-7.19-.61L12%202%209.19%208.63%202%209.24l5.46%204.73L5.82%2021z'/%3e%3c/svg%3e") no-repeat;
		margin: 0 1px;
		filter: drop-shadow(0 1px 1px rgba(0, 0, 0, .2))
	}

	.tu_list .item .right .info-container .user-details {
		color: #718096;
		font-size: 2.93333vw;
		line-height: 1.5;
		font-weight: 500;
		background: linear-gradient(135deg, #4a5568, #718096);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent
	}

	.tu_list .item .right .apply-btn {
		padding: 2.66667vw 5.33333vw;
		font-size: 3.46667vw;
		background: linear-gradient(135deg, #3498db, #8e44ad);
		color: #fff;
		border-radius: 3.2vw;
		text-align: center;
		font-weight: 700;
		cursor: pointer;
		transition: all .3s ease;
		box-shadow: 0 .53333vw 2vw #667eea4d;
		position: relative;
		overflow: hidden;
		letter-spacing: .5px
	}






	.notice {
		padding: 2.66667vw
	}

	.notice .notice-swiper {
		height: 11.2vw;
		border-radius: 2.66667vw;
		border: 1px solid #fff;
		padding: 0 2.66667vw
	}

	.nav_box {
		display: flex;
		align-items: center;
		justify-content: space-around;
		border: 1px solid #fff;
		margin: 1.38667vw 2.66667vw;
		border-radius: 2.66667vw;
		padding: 4vw 2.66667vw;
		background: linear-gradient(135deg, #fff, #f8f9fa)
	}

	.nav_box .x_p {
		text-align: center;
		color: #34196a;
		flex: 1;
		font-size: 3.46667vw
	}

	.nav_box .x_p img {
		height: 10.66667vw
	}

	.agent {
		margin: 20px 20px 0;
		padding: 5px 10px;
		background: linear-gradient(135deg, #fff, #f8f9fa);
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-radius: 20px;
		color: #34196a;
		font-weight: bold;
	}

	.agent>p:first-child {
		font-weight: 700;
		color: #34196a;
		font-size: 4vw;
		position: relative;
		padding-left: 2.13333vw
	}

	.agent>p:first-child:before {
		content: "";
		display: block;
		position: absolute;
		width: 1.06667vw;
		height: 4vw;
		background-color: #34196a;
		left: 0;
		top: .8vw
	}
</style>